import type { App } from 'vue';
import ManualButton from '@src/Manual/Pages/ManualButton.vue';
import ManualDrawer from '@src/Manual/Pages/ManualDrawer.vue';
import ManualCrudGrid from '@src/Manual/Pages/Embeds/ManualCrudGrid.vue';
import { registerEmbedComponent } from '@src/Manual/Pages/composables/useManualEmbeds';

/**
 * Modular setup — registers the layout-slot components the provider adds to
 * app('layout.components') ('header-actions' → ManualButton, 'drawer-right'
 * → ManualDrawer), and the live-demo embed components (islands are mounted
 * into server-rendered manual HTML by useManualEmbeds via its own registry).
 */
export function setup(app: App): void {
    app.component('ManualButton', ManualButton);
    app.component('ManualDrawer', ManualDrawer);

    registerEmbedComponent('ManualCrudGrid', ManualCrudGrid);
}
